import React from 'react';
import { object, func, bool } from 'prop-types';

import { ReactQuillWrapped } from '../../components/react-quill';
import { ContentWrapper, FormFieldActions, FormFieldButton, ReactQuillWrappedContainer } from './styled-components';

export const CommentContent = ({
  commentText,
  editComment,
  quillHandler,
  setEditComment,
  commentHandler,
  cancelCommentHandler,
}) => (editComment ?
  (<ReactQuillWrappedContainer>
    <ReactQuillWrapped
      height="200px"
      width="563px"
      withPaddings
      theme="snow"
      value={commentText.content}
      onChange={quillHandler}
    />
    <FormFieldActions>
      <FormFieldButton
        disabled={!commentText.text.length}
        onClick={commentHandler}
      >Save
      </FormFieldButton>
      <FormFieldButton onClick={cancelCommentHandler} cancel >Cancel changes</FormFieldButton>
    </FormFieldActions>
  </ReactQuillWrappedContainer>) :
  (
    <ContentWrapper>
      <ReactQuillWrapped
        maxHeight="200px"
        width="563px"
        theme={null}
        value={commentText.content}
        readOnly
      />
      <FormFieldActions>
        <FormFieldButton
          onClick={(e) => {
            e.preventDefault();
            setEditComment(true);
          }}
        >Edit
        </FormFieldButton>
        <FormFieldButton onClick={cancelCommentHandler} cancel >Cancel changes</FormFieldButton>
      </FormFieldActions>
    </ContentWrapper>
  )
);

CommentContent.propTypes = {
  commentText: object.isRequired,
  editComment: bool.isRequired,
  quillHandler: func.isRequired,
  setEditComment: func.isRequired,
  commentHandler: func.isRequired,
  cancelCommentHandler: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modals/change-status/comment.js